import React from "react";
import FormattedDuration from "react-intl-formatted-duration";
import { FormattedDate, FormattedTime } from "react-intl";

export const QueueHistoryTableRow = props => {

    const { entry } = props;
    const { sms_user_name, sms_application_name, sms_ctag, duration_seconds, state, created_at } = entry;

    return (
        <tr>
            <td>
                {sms_user_name || '-'}
            </td>
            <td>
                {sms_application_name}
            </td>
            <td>
                {sms_ctag}
            </td>
            <td>
                <FormattedDuration
                    seconds={duration_seconds}
                    unitDisplay="short"
                    format="{minutes} {seconds}"
                />
            </td>
            <td className="align-middle">
                <small className="align-middle">
                    <FormattedDate value={created_at}/>
                    &nbsp;
                    <FormattedTime value={created_at}/>
                </small>
            </td>
            <td className={`text-capitalize ${state === 'COMPLETED' ? 'text-success' : state === 'ABANDONED' ? 'text-danger' : ''}`}>
                {state.toLowerCase()}
            </td>
        </tr>
    );

};